module.exports = __webpack_public_path__ + "img/maps_pin_a.275a5d20.png";